/** Resolves Sentry DSN from runtime config.js first, then Vite build-time env. */
export function getSentryDsn(): string | undefined {
  if (typeof window !== "undefined") {
    const runtimeDsn = (window as { __ENV__?: Record<string, string> }).__ENV__?.VITE_SENTRY_DSN;
    if (runtimeDsn) {
      return runtimeDsn;
    }
  }

  const buildDsn = import.meta.env.VITE_SENTRY_DSN;
  return buildDsn || undefined;
}
